import { constructEnum } from '@/lib/enum';

export default constructEnum('BoardShowReviewInfoOption', {
  SHOW_THUMBNAIL: 1,
  SHOW_SCORE: 2,
  SHOW_CREATED_AT: 4,
  SHOW_LIKES_COUNT: 8,
  EMPHASIZE_MESSAGE: 16
});
